import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Props {
  error: string;
  loading: 'idle' | 'pending' | 'success' | 'failed';
  current_screen: 'list' | 'chat' | 'pinned' | 'members' | 'replys';
  focusSearch: boolean;
}

const initialState = {
  loading: 'idle',
  current_screen: 'list',
  focusSearch: false,
} as Props;

const mobile_screen_flow = createSlice({
  name: 'activeStatus',
  initialState,
  reducers: {
    changeCurrentScreen(
      state,
      action: PayloadAction<'list' | 'chat' | 'pinned' | 'members' | 'replys'>
    ) {
      state.current_screen = action.payload;
    },
    focusSearch(state, action: PayloadAction<boolean>) {
      state.focusSearch = action.payload;
    },
  },
  extraReducers: () => undefined,
});
const getCurrentScreen = state => state.mobile_screen_flow.current_screen;
export const getCurrentScreenView = createSelector(getCurrentScreen, current => current);

const getSearchFocus = state => state.mobile_screen_flow.focusSearch;
export const getCurrentSearchFocus = createSelector(getSearchFocus, nav => nav);

export const { changeCurrentScreen, focusSearch } = mobile_screen_flow.actions;
export default mobile_screen_flow.reducer;
